import React from 'react'
import { Modal, Form, Select, Radio, ColorPicker } from 'antd'
import { Settings } from '../types'

interface SettingsModalProps {
  visible: boolean
  settings: Settings
  onSave: (settings: Partial<Settings>) => void
  onCancel: () => void
}

const SettingsModal: React.FC<SettingsModalProps> = ({
  visible,
  settings,
  onSave,
  onCancel
}) => {
  const [form] = Form.useForm()

  // 解决重开时显示旧值：当 visible 变化且为 true 时，重设初始值
  React.useEffect(() => {
    if (visible) {
      form.setFieldsValue(settings)
    }
  }, [visible, settings, form])

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      // 规范化午休颜色为字符串（兼容 Color 对象）
      const payload: any = { ...values }
      const lc: any = values?.lunch_color
      if (lc && typeof lc === 'object') {
        if (typeof lc.toRgbString === 'function') {
          payload.lunch_color = lc.toRgbString()
        } else if (lc.metaColor) {
          const { r, g, b, a } = lc.metaColor
          payload.lunch_color = `rgba(${r}, ${g}, ${b}, ${typeof a === 'number' ? a : 1})`
        }
      }
      await onSave(payload)
      form.resetFields()
      onCancel() // 保存后关闭弹窗
    } catch (error) {
      console.error('Form validation failed:', error)
    }
  }

  return (
    <Modal
      title="设置"
      open={visible}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      onOk={handleSubmit}
      okText="保存"
      cancelText="取消"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={settings}
      >
        <Form.Item
          name="font_size"
          label="字号"
          rules={[{ required: true, message: '请选择字号' }]}
        >
          <Select>
            <Select.Option value="small">小</Select.Option>
            <Select.Option value="medium">中</Select.Option>
            <Select.Option value="large">大</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="theme_color"
          label="主题色"
          rules={[{ required: true, message: '请选择主题色' }]}
        >
          <Radio.Group>
            <Radio.Button value="rgb(24, 144, 255)">蓝色</Radio.Button>
            <Radio.Button value="rgb(82, 196, 26)">绿色</Radio.Button>
            <Radio.Button value="rgb(245, 74, 69)">红色</Radio.Button>
            <Radio.Button value="rgb(122, 53, 240)">紫色</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="lunch_color"
          label="午休背景色（12:00-14:00）"
        >
          <ColorPicker showText />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SettingsModal